import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsUrl } from 'class-validator';
import { PromotionExposeGroup } from '../interface';
export class FixturePromotionImagesDto {
}
__decorate([
    ApiProperty({
        type: () => String,
        description: 'url of square image/logo',
        example: 'http://res.cloudinary.com/druhu3xb6/image/upload/v1498514961/Eataly/15_discount_square.png',
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsUrl(undefined, { always: true }),
    __metadata("design:type", String)
], FixturePromotionImagesDto.prototype, "imageSquareUrl", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        description: 'url of image/logo',
        example: 'http://res.cloudinary.com/druhu3xb6/image/upload/v1498514961/Eataly/15_discount_square.png',
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ groups: [PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    IsNotEmpty({ always: true }),
    IsUrl(undefined, { always: true }),
    __metadata("design:type", String)
], FixturePromotionImagesDto.prototype, "imageUrl", void 0);
//# sourceMappingURL=FixturePromotionImagesDto.js.map